import {VehicleItem} from '../../../types/api/api';
import {ImportVehicle, ImportVehicleAttribute} from '../types/ImportVehicle';

function buildVehicleName(item: VehicleItem): string {
  const r = item.resolvedVehicle;
  const parts = [r.make, r.model, r.year].filter((x): x is string => x !== undefined && x !== null);
  if (parts.length > 0) {
    return parts.join(' ');
  }
  const inputText = item.rawData.input_text;
  if (inputText) {
    return inputText;
  }
  return '—';
}

function buildSpecs(item: VehicleItem): string {
  const r = item.resolvedVehicle;
  const parts: string[] = [];
  if (r.power !== undefined && r.power !== null) {
    parts.push(`${r.power} kW`);
  }
  if (r.transmission) {
    parts.push(r.transmission);
  }
  if (r.drive) {
    parts.push(r.drive);
  }
  if (r.fuel) {
    parts.push(r.fuel);
  }
  if (r.mileage !== undefined && r.mileage !== null) {
    parts.push(`${r.mileage.toLocaleString()} km`);
  }
  return parts.join(' • ');
}

function rawDataToAttributes(rawData: {[key: string]: string}): ImportVehicleAttribute[] {
  return Object.entries(rawData)
    .filter(([key]) => key.length > 0)
    .map(([label, value]) => ({label, value: String(value)}));
}

export function mapVehicleItemToImportVehicle(item: VehicleItem): ImportVehicle {
  const r = item.resolvedVehicle;
  return {
    id: item.id,
    nr: String(item.rowIndex + 1).padStart(4, '0'),
    name: buildVehicleName(item),
    specs: buildSpecs(item),
    hasVat: r.vatDeductible ?? false,
    rowStatus: item.rowStatus,
    features: r.equipment ?? [],
    attributes: rawDataToAttributes(item.rawData),
    make: r.make ?? undefined,
    model: r.model ?? undefined,
    year: r.year ?? undefined,
    power: r.power ?? undefined,
    transmission: r.transmission ?? undefined,
    fuel: r.fuel ?? undefined,
    drive: r.drive ?? undefined,
    mileage: r.mileage ?? undefined,
  };
}
